import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateY(${(props) => props.translateY}px);
  left: ${(props) => props.translateX}px;
`;

export const Content = styled.div`
  padding: 6px 0px 12px 0px;
  margin: 0 13px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: fit-content;
  row-gap: 9.51px;
  border-top: 1px solid #4C555C;
`;

export const PickerContent = styled.div`
  background: #32383D;
  max-width: 224px;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: -2px 4px 6px rgba(33, 30, 30, 0.2);

  > div {
    box-shadow: none;
    box-shadow: rgb(0 0 0 / 0%) 0px 0px 2px, rgb(0 0 0 / 0%) 0px 4px 8px !important;
  }

  > div > div:first-child {
    box-sizing: border-box;
    height: 154px;
  }

  > div:first-child > div:last-child {
    display: flex;
    flex-direction: column;
    row-gap: 6px;
    > div {
      padding: 0;
    }
  }

  > div:first-child > div:last-child {
    background-color: #32383D;
    padding: 6px 13px 14px 13px !important;

    &:before {
      content: "COR ATUAL DA LEGENDA";
      font-family: 'Roboto', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      font-variant: small-caps;

      color: #FFFFFF;
    }

    > div:first-child > div:first-child > div {
      width: 16px;
      height: 16px;
      border: 1px solid #FFFFFF !important;
    }

    > div:last-child > div:last-child {
      display: none;
      visibility: hidden;
    }

    > div:last-child > div:first-child {
      > div {
        position: relative !important;
        z-index: 0;

        &:before {
          z-index: 1;
          position: absolute;
          top: 50%;
          left: 16px;
          transform: translateY(-50%);
          content: "HEX";
          height: 16px;
          display: flex;
          align-items: center;
          padding-right: 12px;
          border-right: 1px solid #A1B4C4;

          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 14px;

          font-variant: small-caps;


          color: white;
        }
      }

      input {
        box-sizing: border-box;
        width: 100% !important;
        height: 28px !important;
        background-color: #4C555C;
        box-shadow: #ffffff00 0px 0px 0px 1px inset !important;
        color: white !important;
        padding-left: 10px;
      }
      label {
        display: none !important;
        visibility: hidden;
      }
    }
  }
`;

export const ContentTitle = styled.h3`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #FFFFFF;

  font-variant: small-caps;
`;

export const ColorOptions = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8.3px;
`;

export const ColorOption = styled.div`
  background-color: ${(props) => props.color};
  width: 21.45px;
  height: 21.45px;
  content: "";
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid #00000000;
  ${(props) => props.active && css`
    border: 2px solid #FFF;
  `}
  &:hover {
    border: 2px solid ${(props) => (props.active ? '#A1B4C4' : '#FFFFFF')};
  }
`;
